<template>
  <div></div>
</template>

<script>
import { httpError } from "@/models/httpError";
export default {
  data() {
    return {
      search: "",
      editedItem: {},
      editedIndex: 0,
      pagination: {
        descending: true,
        //page: 0,
        rowsPerPage: 10, // -1 for All
        //sortBy: "firstName"
        //totalItems: number
      },
      actions: {
        text: "Actions",
        value: "name",
        align: "center",
        sortable: false,
      },
    };
  },
  methods: {
    getHeaders(item) {
      let cols = Object.getOwnPropertyNames(item)
        .filter((x) => !x.startsWith("_"))
        .map((x) => {
          return {
            text: x,
            value: x,
            sortable: true,
            align: isNaN(item[x]) ? "left" : "right",
          };
        });
      cols.push(this.actions);
      return cols;
    },
    isDateColumn(name) {
      return name.toLowerCase().includes("date");
    },
  },
};
</script>

<style scoped></style>
